import { ISelectedFilters, IFiltersCriteria, IFilterValues } from "../../lib/types/selectedFilters";
import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, OnInit } from "@angular/core";
import { FilterService, CommonService, ShipmentService } from "../../service";
import { SubSink } from "subsink";
import { StorageService } from "src/app/air/modules/common/service/storage/storage.service";
import { MessageService } from 'primeng/api';
import { PortalProfileService } from 'src/app/air/modules/common/service/portal-profile/portal-profile.service'
import STATUS_TYPES from "src/assets/demo/data/globalFilters/statusTypes.json";
import SERVICE_CODES from "src/assets/demo/data/globalFilters/service-codes.json";

@Component({
    selector: "app-filter-panel",
    templateUrl: "./filter-panel.component.html",
    styleUrls: ["./filter-panel.component.scss"],
    standalone: false
})
export class FilterPanelComponent implements OnInit, AfterViewInit, OnDestroy {
    [x: string]: any;
    savedFilters: { name: string; value: string; id: number; selected: boolean }[] = [];
    //#region PUBLIC DATA MEMBERS
    isSaveFilterEnabled: boolean = false;
    public showPanel: boolean = false;
    public isSaveFilter: boolean = true;
    public isEditFilter: boolean = false;
    public showEditFilter: boolean = false;
    public isFilterApplied: boolean = false;
    public newFilterName: string = '';
    public years: Array<number> = [2019, 2020, 2021];
    public filterForEdit: any = { name: '' };
    public maxSelectionLimit: any = 8;
    public statusTypeOptions: any;

    public filterStatus: any = {
        sbus: false,
        representatives: false,
        serviceCodes: false,
        carriers: false,
        flights: false,
        originRegion: false,
        originCountry: false,
        portOfDeparture: false,
        destinationRegion: false,
        destinationCountry: false,
        portOfArrival: false,
        placeOfReceipt: false,
        placeOfDelivery: false,
        // alerts: false,,
        statusType: false
    };
    originRegion: any[] = [];
    originCountry: any[] = [];
    pod: any[] = [];
    allRegionsData: any;
    poa: any[] = [];
    filterFields = {
        originRegion: 1,
        originCountry: 2,
        portOfDeparture: 3,
        destinationRegion: 4,
        destinationCountry: 5
    }
    originDetails: any;
    destinationDetails: any;

    public changeDetector: any = {
        representatives: false,
        customerServiceRepresentatives: false,
        sbus: false,
        serviceCodes: false,
        carriers: false,
        flights: false,
        originRegion: false,
        originCountry: false,
        portOfDeparture: false,
        destinationRegion: false,
        destinationCountry: false,
        portOfArrival: false,
        placeOfReceipt: false,
        placeOfDelivery: false,
        statusType: false,
        // alerts: false,
        events: false,
        exception: false,
        filterUpdated: false
    };

    public selectedFilters: any = {
        companies: [],
        representatives: [],
        customerServiceRepresentatives: [],
        sbus: [],
        serviceCodes: [],
        carriers: [],
        flights: [],
        originRegion: [],
        originCountry: [],
        portOfDeparture: [],
        destinationRegion: [],
        destinationCountry: [],
        portOfArrival: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
        events: [],
        exception: 0,
        shipmentType: 0,
        statusType: ""  // Initialize with empty string
    };
    public emptyFilter: ISelectedFilters = {
        companies: [],
        representatives: [],
        sbus: [],
        serviceCodes: [],
        carriers: [],
        flights: [],
        originRegion: [],
        originCountry: [],
        portOfDeparture: [],
        destinationRegion: [],
        destinationCountry: [],
        portOfArrival: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
        shipmentType: 0,
        statusType: ""
    };

    public filterList: any = {
        companies: [],
        representatives: [],
        sbus: [],
        serviceCodes: [],
        carriers: [],
        flights: [],
        originRegion: [],
        originCountry: [],
        portOfDeparture: [],
        destinationRegion: [],
        destinationCountry: [],
        portOfArrival: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
        shipmentType: 0,
        statusType: ""
    };

    public suggestedFilterList: any = {
        representatives: [],
        flights: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
        portOfDeparture: [],
        portOfArrival: [],
    };

    public selectedAutoCompleteFilters: any = {
        representatives: [],
        flights: [],
        originRegion: [],
        originCountry: [],
        portOfDeparture: [],
        destinationRegion: [],
        destinationCountry: [],
        portOfArrival: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
    };

    private defaultFilters = {
        companies: [],
        representatives: [],
        sbus: [],
        serviceCodes: [],
        carriers: [],
        flights: [],
        originRegion: [],
        originCountry: [],
        portOfDeparture: [],
        destinationRegion: [],
        destinationCountry: [],
        portOfArrival: [],
        placeOfReceipt: [],
        placeOfDelivery: [],
        shipmentType: 0,
        statusType: ""
    }

    public visibleFilters: Array<string> = [];

    //   savedFilters!: { name: string, value: string, id: number, selected: any }[]

    //#endregion

    //#region PRIVATE DATA MEMBERS
    private undoFilter: any = {};
    private filterSubscription = new SubSink();
    private subscription = new SubSink();
    isSavefilterDisabled: boolean = true;
    isRefreshed: boolean = true;
    selectedCompany!: string;
    destinationRegion: any;
    destinationCountry: any;
    allPod: any[];
    allPoa: any[];
    //#endregion

    constructor(
        private filterService: FilterService,
        private shipmentService: ShipmentService,
        private storageService: StorageService,
        private commonService: CommonService,
        private messageService: MessageService,
        private changeDetectorRef: ChangeDetectorRef,
        private portalProfileService: PortalProfileService
    ) {

        this.visibleFilters = [
            "statusType",
            "representatives",
            "sbus",
            "serviceCodes",
            "carriers",
            "flights",
            'originRegion',
            'originCountry',
            "portOfDeparture",
            'destinationRegion',
            'destinationCountry',
            'portOfArrival',
            "placeOfReceipt",
            'placeOfDelivery',
        ]

    }

    ngOnInit() {
        this.statusTypeOptions = STATUS_TYPES;


        // Get stored filters or use default empty filter
        const storedFilters = this.storageService.getItem('filters');
        if (storedFilters) {
            // Merge stored filters with default values to ensure all properties exist
            this.selectedFilters = {
                ...this.selectedFilters,
                ...storedFilters
            };
        };
        if (!this.isFilterEmpty()) {

            this.filterService.setIsFilterSelectedStatus(true);
        }
        const companyCode = this.selectedFilters.companies[0];
        this.getSavedFilters(companyCode);
        this.populateOriginDestinationFilters();
    }


    ngAfterViewInit(): void {
        this.populateFilterOptions('');
        this.subscription.add(
            this.filterService.filterVisibilitySubject.subscribe(
                (visibility: boolean) => {
                    if (visibility != null) {
                        this.showPanel = visibility;
                        if (this.isFilterApplied) {
                            let filters = this.storageService.getItem('filters')
                            this.selectedFilters = filters;
                            this.setSelectedAutoCompleteFilters();
                        }
                    }
                }
            ),
            this.filterService.$filterSelection.subscribe(
                (selectedFilters: ISelectedFilters) => {
                    if (selectedFilters) {
                        this.selectedFilters = JSON.parse(JSON.stringify(selectedFilters));
                        //  console.log("FILTER COMPONENT :: ngAfterViewInit() :: selectedFilters : ", this.selectedFilters);
                        this.setSelectedAutoCompleteFilters(selectedFilters);
                        // if (this.selectedFilters?.companies) {
                        //     if (Array.isArray(this.selectedFilters.companies))
                        //       //  this.getSavedFilters(this.selectedFilters.companies[0]);
                        //     // else
                        //     //     this.getSavedFilters(this.selectedFilters.companies);
                        // }
                        const storedGlobalFilter = this.storageService.getItem('globalFilters');
                        if (storedGlobalFilter == null)
                            this.populateFilterOptions('');
                        else this.filterList = storedGlobalFilter;
                    }
                }
            ),
            this.shipmentService.$shipmentTypeSubject.subscribe(
                (shipmentType: number) => {
                    if (shipmentType != null) {
                        this.selectedFilters.shipmentType = shipmentType;
                        this.populateFilterOptions('');
                    }
                }
            ),
            this.filterService.$companyChanged.subscribe(companyCode => {
                if (!this.isRefreshed) {
                    this.filterService.filterSelectionDownloadOption.next("");
                }
                this.isRefreshed = false;
                if (companyCode != null)
                    this.populateFilterOptions('');
            }),
            this.filterService.filterSelectionDownloadOption.subscribe(state => {
                if (state && state != null)
                    this.isFilterApplied = true;
                else
                    this.isFilterApplied = false;
            })

        );

    }

    getSavedFilters(companyCode: any): void {
        this.savedFilters = []; // Reset saved filters
        this.portalProfileService.getSavedFilters().subscribe(
            (res: any) => {
                //      console.log('API Response:', res); // Log the API response
                if (res && res.data) {
                    this.savedFilters = res.data
                        .filter((filter: any) => filter.filterName && filter.filterJsonText) // Filter out empty entries
                        .map((filter: any) => ({
                            id: filter.id,
                            name: filter.filterName,
                            value: filter.filterJsonText,
                            selected: false
                        }));
                    //      console.log('Saved Filters:', this.savedFilters); // Log the saved filters
                }
            },
            (error) => {
                console.error('Error fetching saved filters:', error); // Log any errors
            }
        );
    }
    saveEnabled() {
        if (this.isFilterEmpty() || this.newFilterName.length == 0)
            this.isSavefilterDisabled = true
        else
            this.isSavefilterDisabled = false
    }
    isFilterEmpty() {
        if (
            this.selectedFilters?.carriers?.length > 0 ||
            this.selectedFilters?.placeOfDelivery?.length > 0 ||
            this.selectedFilters?.placeOfReceipt?.length > 0 ||
            this.selectedFilters?.portOfArrival?.length > 0 ||
            this.selectedFilters?.portOfDeparture?.length > 0 ||
            this.selectedFilters?.representatives?.length > 0 ||
            this.selectedFilters?.sbus?.length > 0 ||
            this.selectedFilters?.serviceCodes?.length > 0 ||
            this.selectedFilters?.originRegion?.length > 0 ||
            this.selectedFilters?.destinationRegion?.length > 0 ||
            this.selectedFilters?.originCountry?.length > 0 ||
            this.selectedFilters?.destinationCountry?.length > 0 ||
            (this.selectedFilters?.shipmentType && this.selectedFilters?.shipmentType != 0) ||
            this.selectedFilters?.flights?.length > 0 ||
            this.selectedFilters?.statusType != ""
        ) return false;
        else return true;
    }
    createFilter() {
        if (JSON.stringify(this.selectedFilters) == JSON.stringify(this.emptyFilter) || this.isFilterEmpty()) {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                life: 10000,
                summary: 'Error',
                detail: 'Please select a filter criteria to save the filter!'
            });
            return;
        }
        if (this.newFilterName.length == 0) {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                life: 10000,
                summary: 'Error',
                detail: 'Please provide the filter name to save the filter!'
            });
            return;
        }

        const filterData = {
            filterJsonText: JSON.stringify(this.selectedFilters),
            filterName: this.newFilterName,
            id: null // New filter, so savedFilterId is 0
        };

        this.portalProfileService.setSavedFilters(filterData).subscribe((res: any) => {
            if (res) {
                const filter = {
                    id: res.id, // Use the ID returned from the API
                    name: this.newFilterName,
                    value: JSON.stringify(this.selectedFilters),
                    selected: false
                };
                this.savedFilters.unshift(filter); // Add the new filter to the list
                this.undoFilter = JSON.parse(JSON.stringify(filter));
                this.isSaveFilter = true;
                this.messageService.add({
                    key: 'bcu', severity: 'success',
                    detail: 'Filter ' + '“' + this.newFilterName + '” saved successfully.',
                    data: 'filterCreated',
                    life: 10000,
                });
                this.newFilterName = ''; // Reset the filter name input
                this.isSaveFilter = true;
                this.showEditFilter = true;
                this.getSavedFilters(this.companyCode);


            }
        });
    }
    selectFilter(filter: any) {
        if (filter.selected)
            return;
        this.savedFilters.map((tFilter: any) => {
            tFilter.selected = false;
        });
        filter.selected = true;
        this.selectedFilters = JSON.parse(filter.value);
        this.setSelectedAutoCompleteFilters();
        this.populateFilterOptions('');
    }

    editFilter(filter: any) {
        this.isEditFilter = true;
        this.showEditFilter = false;
        this.filterForEdit = filter;
        this.selectedFilters = JSON.parse(filter.value);
        this.populateFilterOptions('')
        this.undoFilter = JSON.parse(JSON.stringify(filter));
    }


    removeSavedFilter(filter: any) {

        // Create the filter data object in the same format as save
        const filterData = {
            filterJsonText: JSON.stringify(this.selectedFilters),
            filterName: filter.name,
            id: filter.id
        };

        // Call the API to delete the filter
        this.portalProfileService.deleteSavedFilters(filterData).subscribe(
            (res) => {
                if (res) {

                    const index = this.savedFilters.indexOf(filter);
                    if (index > -1) {

                        this.undoFilter = JSON.parse(JSON.stringify(filter));


                        this.savedFilters.splice(index, 1);

                        // Show a success message
                        this.messageService.add({
                            key: 'bcu',
                            severity: 'success',
                            detail: 'Filter "' + filter.name + '" has been successfully deleted.',
                            data: 'filterRemoved',
                            life: 10000,
                        });
                    } else {
                        this.undoFilter = undefined;
                    }
                }
            },
            (error) => {
                console.error('Error deleting filter:', error);
                this.messageService.add({
                    key: 'bcu',
                    severity: 'error',
                    detail: 'Failed to delete filter "' + filter.name + '". Please try again.',
                    life: 10000,
                });
            }
        );
    }
    undoOperation(operation: string) {
        switch (operation) {
            case "filterCreated": {
                this.portalProfileService.setSavedFilters({
                    filterJsonText: "",
                    filterName: "",
                    savedFilterId: this.undoFilter.id
                }).subscribe((res) => {
                    if (res) {
                        this.savedFilters.shift();
                        this.undoFilter = null;
                    }
                })
                break;
            }
            case "filterModified": {
                this.portalProfileService.setSavedFilters({
                    filterJsonText: this.undoFilter.value,
                    filterName: this.undoFilter.name,
                    savedFilterId: this.undoFilter.id
                }).subscribe((res) => {
                    if (res) {
                        const index = this.savedFilters.indexOf(this.filterForEdit);
                        if (index > -1) {
                            this.savedFilters[index] = JSON.parse(JSON.stringify(this.undoFilter));
                            this.selectedFilters = JSON.parse(this.undoFilter.value)
                        }
                        this.undoFilter = null;
                    }
                })
                break;
            }
            case "filterRemoved": {
                if (this.undoFilter) {
                    this.portalProfileService.setSavedFilters({
                        filterJsonText: this.undoFilter.value,
                        filterName: this.undoFilter.name,
                        savedFilterId: this.undoFilter.id
                    }).subscribe((res: any) => {
                        if (res) {
                            this.undoFilter.id = res.id;
                            this.savedFilters.unshift(this.undoFilter);
                        }
                        this.undoFilter = null;
                    })
                }
                break;
            }
        }
        this.messageService.clear('bcu');
    }
    //#endregion
    resetCountries() {
        // Reset origin country list to include all countries
        this.originCountry = this.filterUnknown(
            this.allRegionsData.reduce((acc, region) =>
                acc.concat(region.countries.map(country => ({
                    label: `${country.countryName} (${country.countryCode})`,
                    value: country.countryCode
                }))), []
            ).sort((a, b) => a.label.localeCompare(b.label)));

        // Reset destination country list to include all countries
        this.destinationCountry = this.filterUnknown(
            this.allRegionsData.reduce((acc, region) =>
                acc.concat(region.countries.map(country => ({
                    label: `${country.countryName} (${country.countryCode})`,
                    value: country.countryCode
                }))), []
            ).sort((a, b) => a.label.localeCompare(b.label)));
    }
    populateOriginDestinationFilters() {
        this.filterService.getRegionCountryList(this.defaultFilters).subscribe((data: any) => {
            // Store raw data
            this.allRegionsData = data;

            // Log incoming data
            //       console.log('Region Country Data:', data);

            // Map regions once
            this.originRegion = this.filterUnknown(
                this.allRegionsData.map(region => ({
                    label: region.regionName || region.region,
                    value: region.regionName || region.region
                }))
            ).sort((a, b) => a.label.localeCompare(b.label));

            // Map countries once
            this.originCountry = this.filterUnknown(
                this.allRegionsData.reduce((acc, region) =>
                    acc.concat(region.countries.map(country => ({
                        label: `${country.countryName} (${country.countryCode})`,
                        value: country.countryCode
                    }))), []
                )
            ).sort((a, b) => a.label.localeCompare(b.label));

            // Copy for destination
            this.destinationRegion = [...this.originRegion];
            this.destinationCountry = [...this.originCountry];

            // Log mapped data
            //    console.log('Mapped Origin Region:', this.originRegion);
            //     console.log('Mapped Origin Country:', this.originCountry);

            // Update filter lists
            this.filterList.originRegion = this.originRegion;
            this.filterList.originCountry = this.originCountry;
            this.filterList.destinationRegion = this.destinationRegion;
            this.filterList.destinationCountry = this.destinationCountry;

            // Force change detection
            this.changeDetectorRef.detectChanges();
        });
    }
    // onLocationChange(filterField: number, value: any, selectedFilters: any) {
    //     this.changeDetector[filterField === this.filterFields.originRegion ? 'originRegion' : 'destinationRegion'] = true;

    //     switch (filterField) {
    //         case this.filterFields.originRegion:
    //             if (selectedFilters.originRegion?.length !== 0) {
    //                 this.filterCountryAndPorts("origin", selectedFilters.originRegion);

    //                 const selectedCountryCodes = this.selectedFilters.originCountry.map(country => country.value);
    //                 const validCountries = this.originCountry.filter(country => selectedCountryCodes.includes(country.value));

    //                 if (validCountries.length !== this.selectedFilters.originCountry.length) {
    //                     this.selectedFilters.originCountry = [];
    //                 }
    //             } else {
    //                 this.originCountry = this.filterUnknown(
    //                     this.allRegionsData.reduce((acc, region) =>
    //                         acc.concat(region.countries.map(country => ({
    //                             label: `${country.countryName} (${country.countryCode})`,
    //                             value: country.countryCode
    //                         }))), []
    //                     ).sort((a, b) => a.label.localeCompare(b.label)));

    //                 this.selectedFilters.originCountry = [];
    //             }

    //             this.selectedFilters.portOfDeparture = [];
    //             this.selectedAutoCompleteFilters.portOfDeparture = [];
    //             break;

    //         case this.filterFields.destinationRegion:
    //             if (selectedFilters.destinationRegion?.length !== 0) {
    //                 this.filterCountryAndPorts("destination", selectedFilters.destinationRegion);

    //                 const selectedCountryCodes = this.selectedFilters.destinationCountry?.map(country => country.value) || [];
    //                 const validCountries = this.destinationCountry.filter(country => selectedCountryCodes.includes(country.value));

    //                 if (validCountries.length !== this.selectedFilters.destinationCountry.length) {
    //                     this.selectedFilters.destinationCountry = [];
    //                 }
    //             } else {
    //                 this.destinationCountry = this.filterUnknown(
    //                     this.allRegionsData.reduce((acc, region) =>
    //                         acc.concat(region.countries.map(country => ({
    //                             label: `${country.countryName} (${country.countryCode})`,
    //                             value: country.countryCode
    //                         }))), []
    //                     ).sort((a, b) => a.label.localeCompare(b.label)));

    //                 this.selectedFilters.destinationCountry = [];
    //             }

    //             this.selectedFilters.portOfArrival = [];
    //             this.selectedAutoCompleteFilters.portOfArrival = [];
    //             break;

    //         case this.filterFields.originCountry:
    //         case this.filterFields.destinationCountry:
    //             // Handle country changes if needed
    //             break;

    //         default:
    //             break;
    //     }

    //    // Force change detection
    //         this.changeDetectorRef.markForCheck();
    //         this.changeDetectorRef.detectChanges();
    // }
    // filterCountryAndPorts(
    //     type: "origin" | "destination",
    //     selectedRegions: any[]
    // ) {
    //     // Determine the appropriate region list based on the type
    //     const regionList =
    //         type === "origin" ? this.allRegionsData : this.allRegionsData;
    //     const detailsList =
    //         type === "origin" ? this.allRegionsData : this.allRegionsData;

    //     // Normalize selectedRegions to an array
    //     const selectedRegionArray = Array.isArray(selectedRegions)
    //         ? selectedRegions
    //         : [selectedRegions];

    //     // Filter the regions that match any of the selected regions
    //     const selectedRegionDataList = regionList.filter((region) =>
    //         selectedRegionArray.includes(region.regionName)
    //     );

    //     if (selectedRegionDataList.length !== 0) {
    //         let countryList: { id: string; label: string; value: string }[] =
    //             [];

    //         // Collect countries from the filtered regions

    //         // selectedRegionDataList.forEach(region => {
    //         //     const selectedRegionData = detailsList.find(detail => detail.regionName === region.regionName);
    //         //     if (selectedRegionData && selectedRegionData.countries) {
    //         //         const countries = selectedRegionData.countries.map(country => ({
    //         //             label: `${country.countryName} (${country.countryCode})`,
    //         //             value: country.countryCode
    //         //         }));
    //         //         countryList = countryList.concat(countries); // Concatenate the new countries to the list
    //         //     }
    //         // });

    //         selectedRegionDataList.forEach((region) => {
    //             const selectedRegionData = detailsList.find(
    //                 (detail) => detail.regionName === region.regionName
    //             );
    //             if (selectedRegionData && selectedRegionData.countries) {
    //                 const countries = selectedRegionData.countries.map(
    //                     (country) => ({
    //                         label: `${country.countryName} (${country.countryCode})`,
    //                         value: country.countryCode,
    //                     })
    //                 );
    //                 countryList = countryList.concat(countries); // Concatenate the new countries to the list
    //             }
    //         });

    //         // Sort the countryList by the `label` property
    //         countryList.sort((a, b) => a.label.localeCompare(b.label));

    //         if (type === "origin") {
    //             // console.log(countryList);
    //             this.originCountry = countryList;
    //         } else {
    //             // console.log(countryList);
    //             this.destinationCountry = countryList;
    //         }
    //     }

    //     // if (!selectedRegions || selectedRegions.length === 0) {
    //     //     this.updateCountryAndPortOptions(type);
    //     //     return;
    //     // }

    //     if (type === "origin") {
    //         // console.log(countryList);
    //         this.getPODPOAList("POD");
    //     } else {
    //         // console.log(countryList);
    //         this.getPODPOAList("POA");
    //     }
    // }
    onLocationChange(filterField: number, value: any, selectedFilters: any) {
        // Set change detector flag and trigger onFilterChange
        this.changeDetector[filterField === this.filterFields.originRegion ? 'originRegion' : 'destinationRegion'] = true;
        this.onFilterChange();

        switch (filterField) {
            case this.filterFields.originRegion:
                if (selectedFilters.originRegion?.length !== 0) {
                    // Update countries based on selected regions
                    this.filterCountryAndPorts("origin", selectedFilters.originRegion);

                    // Validate existing country selections
                    if (this.selectedFilters.originCountry?.length) {
                        const selectedCountryCodes = this.selectedFilters.originCountry.map(country => country.value);
                        const validCountries = this.originCountry.filter(country =>
                            selectedCountryCodes.includes(country.value)
                        );

                        // Reset if selected countries are not valid for new region
                        if (validCountries.length !== this.selectedFilters.originCountry.length) {
                            this.selectedFilters.originCountry = [];
                        }
                    }
                } else {
                    // Reset to show all countries when no region selected
                    this.resetCountries();
                    this.selectedFilters.originCountry = [];
                }

                // Reset dependent fields
                this.selectedFilters.portOfDeparture = [];
                this.selectedAutoCompleteFilters.portOfDeparture = [];

                // Update filter lists
                this.filterList.originCountry = this.originCountry;
                this.getPODPOAList("POD");
                break;

            case this.filterFields.destinationRegion:
                if (selectedFilters.destinationRegion?.length !== 0) {
                    // Update countries based on selected regions
                    this.filterCountryAndPorts("destination", selectedFilters.destinationRegion);

                    // Validate existing country selections
                    if (this.selectedFilters.destinationCountry?.length) {
                        const selectedCountryCodes = this.selectedFilters.destinationCountry.map(country => country.value);
                        const validCountries = this.destinationCountry.filter(country =>
                            selectedCountryCodes.includes(country.value)
                        );

                        // Reset if selected countries are not valid for new region
                        if (validCountries.length !== this.selectedFilters.destinationCountry.length) {
                            this.selectedFilters.destinationCountry = [];
                        }
                    }
                } else {
                    // Reset to show all countries when no region selected
                    this.resetCountries();
                    this.selectedFilters.destinationCountry = [];
                }

                // Reset dependent fields
                this.selectedFilters.portOfArrival = [];
                this.selectedAutoCompleteFilters.portOfArrival = [];

                // Update filter lists
                this.filterList.destinationCountry = this.destinationCountry;
                this.getPODPOAList("POA");
                break;

            case this.filterFields.originCountry:
            case this.filterFields.destinationCountry:
                // Update ports when country selection changes
                const portType = filterField === this.filterFields.originCountry ? "POD" : "POA";
                this.getPODPOAList(portType);
                break;
        }

        // Update filter status and trigger change detection
        this.updateFilterStatus(filterField === this.filterFields.originRegion ? 'originRegion' : 'destinationRegion');
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
    }
    getPODPOAList(type: "POA" | "POD") {
        const filters: IFiltersCriteria = this.filterService.getIds(
            this.selectedFilters
        );

        switch (type) {
            case "POA":
                this.poa = [];
                this.suggestedFilterList.portOfArrival = [];
                this.commonService.getPOA(filters).subscribe((data: any) => {
                    if (data != null && data != undefined) {
                        this.filterList.portOfArrival = data.map((port) => {
                            port.value = `${port.value} (${port.id})`;
                            return port;
                        });
                        this.poa = this.filterList.portOfArrival;
                        this.suggestedFilterList.portOfArrival =
                            this.filterList.portOfArrival;
                    } else {
                        this.filterList.portOfArrival = [];
                        this.selectedFilters.portOfArrival = [];
                    }
                    this.checkEmpty();
                    this.updateFilterStatus("portOfArrival");
                });

                break;
            case "POD":
                this.pod = [];
                this.suggestedFilterList.portOfDeparture = [];
                this.commonService.getPOD(filters).subscribe((data: any) => {
                    if (data != null && data != undefined) {
                        this.filterList.portOfDeparture = data.map((port) => {
                            port.value = `${port.value} (${port.id})`;
                            return port;
                        });
                        this.pod = this.filterList.portOfDeparture;
                        this.suggestedFilterList.portOfDeparture =
                            this.filterList.portOfDeparture;
                    } else {
                        this.filterList.portOfDeparture = [];
                        this.selectedFilters.portOfDeparture = [];
                    }
                    this.checkEmpty();
                    this.updateFilterStatus("portOfDeparture");
                });
                break;

            default:
                break;
        }
    }
    filterUnknown(options: any[]): any[] {
        return options.filter(
            (option) =>
                !option.label.startsWith("Unknown") &&
                !option.value.startsWith("Unknown")
        );
    }
    private populate: any = {
        statusType: (filters: IFiltersCriteria) => {
            if (!this.changeDetector.status) {
                this.statusTypeOptions = STATUS_TYPES;

            } else {
                this.changeDetector.status = false;
            }
        },
        sbus: (filters: IFiltersCriteria) => {
            if (!this.changeDetector.sbus) {
                this.filterSubscription.add(
                    this.commonService.getBdpSBUs(filters).subscribe((res: any) => {
                        if (res != null && res != undefined) {
                            this.filterList.sbus = res.map((item: any) => ({
                                id: item.id,
                                value: item.value,
                                label: item.value // Add label for dropdown display
                            })).filter(item =>
                                item.id != null &&
                                item.value != null
                            );
                        } else {
                            this.filterList.sbus = [];
                            this.selectedFilters.sbus = [];
                        }
                        this.checkEmpty();
                        this.updateFilterStatus('sbus');
                    })
                );
            } else {
                this.changeDetector.sbus = false;
            }
        },
        // sbus: (filters: IFiltersCriteria) => { //#DONE
        //     if (!this.changeDetector.sbus) {
        //         this.filterSubscription.add(
        //             this.commonService
        //                 .getBdpSBUs(filters)
        //                 .subscribe((res: any) => {
        //                     if (res != null && res != undefined) {
        //                         res.map((item: any) => {
        //                             if (item.id != null && item.value != null) {
        //                                 this.filterList.sbus.push(item);
        //                             }
        //                         })
        //                     } else {
        //                         this.filterList.sbus = [];
        //                         this.selectedFilters.sbus = [];
        //                     }
        //                     this.checkEmpty();
        //                     this.updateFilterStatus('sbus');
        //                 })
        //         );
        //     } else {
        //         this.changeDetector.sbus = false;
        //     }
        // },
        representatives: (filters: IFiltersCriteria) => { //#DONE
            if (!this.changeDetector.representatives) {
                this.filterSubscription.add(
                    this.commonService
                        .getBDPRepresentatives(filters)
                        .subscribe((data: any) => {
                            this.filterList.representatives = [];
                            if (data != null && data != undefined) {
                                data.map((item: any) => {
                                    if (item.id != null && item.value != null) {
                                        this.filterList.representatives.push(item);
                                    }
                                })
                            } else {
                                this.filterList.representatives = [];
                                this.selectedFilters.representatives = [];
                            }
                            this.filterService.bdpRepListPromise.next(this.filterList.representatives);
                            this.checkEmpty();
                            this.updateFilterStatus('representatives');
                        })
                );
            } else {
                this.changeDetector.representatives = false;
            }
        },
        serviceCodes: (filters: IFiltersCriteria) => { //#DONE
            if (!this.changeDetector.status) {
                this.filterList.serviceCodes = SERVICE_CODES;
            } else {
                this.changeDetector.status = false;
            }
        },
        carriers: (filters: IFiltersCriteria) => { //#DONE
            if (!this.changeDetector.carriers) {
                this.filterSubscription.add(
                    this.commonService
                        .getBdpCarriers(filters)
                        .subscribe((data: any) => {
                            //     console.log("carrires", data);
                            this.filterList.carriers = [];
                            if (data != null && data != undefined) {
                                data.map((item: IFilterValues) => {
                                    if (item.id != null && item.value != null) {
                                        this.filterList.carriers.push(item);
                                    }
                                })
                            } else {
                                this.filterList.carriers = [];
                                this.selectedFilters.carriers = [];
                            }
                            this.checkEmpty();
                            this.updateFilterStatus('carriers');
                        })
                );
            } else {
                this.changeDetector.carriers = false;
            }
        },
        flights: (filters: IFiltersCriteria) => {
            if (!this.changeDetector.flights) {
                this.filterSubscription.add(
                    this.commonService.getFlights(filters).subscribe((data: any) => {
                        //         console.log('Raw flight data:', data); // Inspect API response
                        this.filterList.flights = [];

                        if (data != null && data != undefined) {
                            data.map((item: IFilterValues) => {
                                if (item.id != null && item.value != null) {
                                    this.filterList.flights.push({
                                        id: item.id,
                                        value: item.value,
                                        label: `${item.value}` // Format display label Add label for dropdown display
                                        // Add other properties if needed
                                    });
                                }
                            });
                        } else {
                            this.filterList.flights = [];
                            this.selectedFilters.flights = [];
                        }

                        //           console.log('Filtered flight list:', this.filterList.flights); // Inspect filtered list
                        this.filterService.vesselNameListPromise.next(this.filterList.flights);
                        this.checkEmpty();
                        this.updateFilterStatus('flights');
                        // this.cdr.detectChanges(); // Trigger change detection
                    })
                );
            } else {
                this.changeDetector.flights = false;
            }
        },
        portOfDeparture: (filters: IFiltersCriteria) => {
            if (!this.changeDetector.portOfDeparture) {
                this.filterSubscription.add(
                    this.commonService
                        .getPOD(filters)
                        .subscribe((data: any) => {
                            if (data != null && data != undefined) {
                                this.filterList.portOfDeparture =
                                    data.map((port: { value: string; id: any; }) => {
                                        port.value = `${port.value}`
                                        return port;
                                    });
                            } else {
                                this.filterList.portOfDeparture = [];
                                this.selectedFilters.portOfDeparture = [];
                            }
                            this.checkEmpty();
                            this.updateFilterStatus('portOfDeparture');
                        })
                );
            } else {
                this.changeDetector.portOfDeparture = false;
            }
        },
        portOfArrival: (filters: IFiltersCriteria) => {
            if (!this.changeDetector.portOfArrival) {
                this.filterSubscription.add(
                    this.commonService
                        .getPOA(filters)
                        .subscribe((data: any) => {
                            if (data != null && data != undefined) {
                                this.filterList.portOfArrival =
                                    data.map((port: { value: string; id: any; }) => {
                                        port.value = `${port.value}`
                                        return port;
                                    });
                            } else {
                                this.filterList.portOfArrival = [];
                                this.selectedFilters.portOfArrival = [];
                            }
                            this.checkEmpty();
                            this.updateFilterStatus('portOfArrival');
                        })
                );
            } else {
                this.changeDetector.portOfArrival = false;
            }
        },
        placeOfReceipt: (filters: IFiltersCriteria) => { //#DONE
            if (!this.changeDetector.placeOfReceipt) {
                this.filterSubscription.add(
                    this.commonService
                        .getPlaceofReceipt(filters)
                        .subscribe((res: any) => {
                            if (res != null && res != undefined) {
                                this.filterList.placeOfReceipt =
                                    res.map((port: { value: string; id: any; }) => {
                                        port.value = `${port.value}`
                                        return port;
                                    });
                            } else {
                                this.filterList.placeOfReceipt = [];
                                this.selectedFilters.placeOfReceipt = [];
                            }
                            this.checkEmpty();
                            this.updateFilterStatus('placeOfReceipt');
                        })
                );
            } else {
                this.changeDetector.placeOfReceipt = false;
            }
        },
        placeOfDelivery: (filters: IFiltersCriteria) => { //#DONE
            if (!this.changeDetector.placeOfDelivery) {
                this.filterSubscription.add(
                    this.commonService
                        .getPlaceOfDelivery(filters)
                        .subscribe((data: any) => {
                            if (data != null && data != undefined) {
                                this.filterList.placeOfDelivery =
                                    data.map((port: { value: string; id: any; }) => {
                                        port.value = `${port.value}`
                                        return port;
                                    });
                            } else {
                                this.filterList.placeOfDelivery = [];
                                this.selectedFilters.placeOfDelivery = [];
                            }
                            this.checkEmpty();
                            this.updateFilterStatus('placeOfDelivery');
                        })
                );
            } else {
                this.changeDetector.placeOfDelivery = false;
            }
        },
    };

    public populateFilterOptions(functionName: any) {
        this.resetFilterStatus();
        this.filterSubscription.unsubscribe();
        if (
            this.selectedFilters[functionName] &&
            !this.changeDetector[functionName]
        ) {
            return;
        }
        const filters: IFiltersCriteria = this.filterService.getIds(
            this.selectedFilters
        );

        this.changeDetector[functionName] = false
        // if (this.selectedFilters.companies.length != 0) {
        for (const populateFun in this.populate) {

            if (populateFun == functionName) {
                this.updateFilterStatus(functionName)
                continue;
            }

            this.populate[populateFun](filters);
        }

        this.changeDetectorRef.detectChanges();
        if (functionName != '') {
            this.changeDetector.filterUpdated = true;
        }
        this.saveEnabled()
    }

    public onFilterApplied(): void {

        if (JSON.stringify(this.selectedFilters) === JSON.stringify(this.emptyFilter) || this.isFilterEmpty()) {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                life: 10000,
                summary: 'Error',
                detail: 'No filter criteria has been selected!'
            });
            this.filterService.setIsFilterSelectedStatus(false);
            return;
        }
        this.filterService.setIsFilterSelectedStatus(true);
        this.filterService.filterSelectionDownloadOption.next('applies');
        const filters: IFiltersCriteria = this.filterService.getIds(
            this.selectedFilters
        );
        //To check that only statusType filter is selected
        if (!this.filterService.isStatusTypeFilterSelectedOnly(filters, 'companies'))
            this.populateFilterOptions('');

        this.filterService.updateFilterSelection(filters, "ApplyFilter");
        this.storageService.setItem("filters", filters);
        this.closeOverlay();
    }

      closeOverlay() {
        const elem = document.getElementsByClassName("p-overlay-mask")[0];
        if (elem) {
            var evObj = document.createEvent("Events");
            evObj.initEvent("click", false, false);
            elem.dispatchEvent(evObj);
        }
    }
    filterCountryAndPorts(type: "origin" | "destination", selectedRegions: any[]) {
        // Normalize selectedRegions to an array
        const selectedRegionArray = Array.isArray(selectedRegions) ? selectedRegions : [selectedRegions];

        // If no regions are selected, show all countries
        if (selectedRegionArray.length === 0) {
            if (type === "origin") {
                this.originCountry = this.filterUnknown(
                    this.allRegionsData.reduce((acc, region) =>
                        acc.concat(region.countries.map(country => ({
                            label: `${country.countryName} (${country.countryCode})`,
                            value: country.countryCode
                        }))), []
                    )
                ).sort((a, b) => a.label.localeCompare(b.label));
            } else {
                this.destinationCountry = this.filterUnknown(
                    this.allRegionsData.reduce((acc, region) =>
                        acc.concat(region.countries.map(country => ({
                            label: `${country.countryName} (${country.countryCode})`,
                            value: country.countryCode
                        }))), []
                    )
                ).sort((a, b) => a.label.localeCompare(b.label));
            }
            return;
        }

        // Filter the countries based on the selected regions
        let countryList: { label: string; value: string }[] = [];

        this.allRegionsData.forEach(region => {
            if (selectedRegionArray.includes(region.regionName || region.region)) {
                if (region.countries) {
                    const countries = region.countries.map(country => ({
                        label: `${country.countryName} (${country.countryCode})`,
                        value: country.countryCode
                    }));
                    countryList = countryList.concat(countries);
                }
            }
        });

        // Sort the countryList by the `label` property
        countryList.sort((a, b) => a.label.localeCompare(b.label));

        // Update the appropriate country list based on the type
        if (type === "origin") {
            this.originCountry = countryList;
        } else {
            this.destinationCountry = countryList;
        }

        // Log the updated country list
        //   console.log('Updated Origin Country List:', this.originCountry);
    }
    closeSidebar() {
        this.filterService.changeFilterVisibility(false);
        this.isEditFilter = false;
        this.showEditFilter = false;
        this.isSaveFilter = true;
    }

    public refreshFilter(filterName: any) {
        if (this.filterList[filterName].length <= 1) {
            const filters: any = JSON.parse(
                JSON.stringify(this.filterService.getIds(this.selectedFilters))
            );
            delete filters[filterName];
            this.populate[filterName](filters);
        }
    }

    private checkEmpty() {
        let emptyFlage: boolean = true;
        for (let filter in this.filterList) {
            if (this.filterList[filter] && this.filterList[filter].length > 0) {
                emptyFlage = false;
            }
        }
    }

    public refelectDateChange(selectedDate: any, filterKey: any) {
        this.selectedFilters[filterKey] = selectedDate;
        // console.log(selectedDate, filterKey);
    }

    public mak(event: any) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }

    keepMultiSelectOpen(event: any) {
        //  event.preventDefault();
        event.stopPropagation();
    }

    private updateFilterStatus(filterName: string) {
        this.filterStatus[filterName] = true;

        if (this.isAllFiltersUpdated())
            this.storageService.setItem("globalFilters", this.filterList);
    }

    /** 
     * Funciton to check all filters api call has been finished
     * and all filters has data after which insert the filters in Local storage.
     * @returns True if all filters has data
     */
    private isAllFiltersUpdated() {
        const filters = Object.keys(this.filterStatus);
        var isUpdated = true;
        filters.forEach((filter: any) => {
            if (!this.filterStatus[filter])
                isUpdated = false;
        });
        return isUpdated;
    }

    resetFilterStatus() {
        const filters = Object.keys(this.filterStatus);
        filters.forEach((filter: any) => { this.filterStatus[filter] = false });
    }

    filterSuggestedList(event: { query: string }, filterName: string | number) {
        if (filterName === 'flights' || filterName === 'representatives') {
            this.suggestedFilterList[filterName] = this.filterList[filterName]
                ?.filter(item =>
                    item.value.toLowerCase().includes(event.query.toLowerCase())
                )
                .map(item => ({
                    id: item.value,      // Use value as ID
                    value: item.value,
                    label: item.value   // Use value for both display and API
                })) || [];
        } else  if (filterName === 'portOfDeparture' || filterName === 'portOfArrival' || filterName === 'placeOfReceipt' || filterName === 'placeOfDelivery') {
        this.suggestedFilterList[filterName] = this.filterList[filterName]
            ?.filter(item =>
                item.value.toLowerCase().includes(event.query.toLowerCase())
            )
            .map(item => ({
                id: item.id,
                value: item.id,     
                label: item.value  
            })) || [];
    }
        else {
            this.suggestedFilterList[filterName] = this.commonService.autoCompleteFilters(
                this.filterList[filterName],
                event.query
            );
        }
    }
    setAutoCompleteFilter(filterName: string | number) {
        this.changeDetector[filterName] = true;

        if (filterName === 'flights' || filterName === 'representatives') {
            // Ensure selected items maintain their display format
            this.selectedAutoCompleteFilters[filterName] = 
                this.selectedAutoCompleteFilters[filterName]?.map(item => ({
                    id: item,
                    value: item,
                    label: item
                })) || [];
    
            // Store values in selectedFilters
            this.selectedFilters[filterName] = 
                this.selectedAutoCompleteFilters[filterName]?.map(item => item.value) || [];
        } else {
            // Handle other fields as before
            const portFields = ['portOfDeparture', 'portOfArrival', 'placeOfReceipt', 'placeOfDelivery'];
           if (portFields.includes(filterName.toString())) {
        // Ensure selected items maintain their display format
        this.selectedAutoCompleteFilters[filterName] = 
            this.selectedAutoCompleteFilters[filterName]?.map(item => ({
                id: item,
                value: item,    // Use ID for API
                label: item // Keep label for display
            })) || [];

        // Store IDs in selectedFilters for API calls
        this.selectedFilters[filterName] = 
            this.selectedAutoCompleteFilters[filterName]?.map(e => e.id);
    }
        }

        this.onFilterChange();
        // Force change detection
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
    }

    setSelectedAutoCompleteFilters(selectedFilters = this.selectedFilters) {
        for (var filter in this.selectedAutoCompleteFilters) {
            if (!this.filterList[filter]) {
                this.selectedAutoCompleteFilters[filter] = [];
                continue;
            }
    
            if (filter === 'flights' || filter === 'representatives') {
                // Restore selected items with proper format
                this.selectedAutoCompleteFilters[filter] =
                    selectedFilters[filter]?.map(value => ({
                        id: value,
                        value: value,
                        label: value
                    })) || [];
            } 
            // else {
            //     this.selectedAutoCompleteFilters[filter] = this.filterList[filter].filter((item: any) => {

            //         if (selectedFilters[filter].includes(item.value))
            //             return item;
            //     })
            // }
        }
    }

    resetSelectedAutoCompleteFilters() {
        for (var filter in this.selectedAutoCompleteFilters)
            this.selectedAutoCompleteFilters[filter] = [];
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.filterSubscription.unsubscribe();
    }
    handleSaveFilterClick(): void {
        if (this.isSaveFilterEnabled) {
            this.isSaveFilter = false;
            this.showEditFilter = false;
            // Additional logic for saving the filter
        }
    }

    saveFilter() {
        const filterData = {
            filterJsonText: JSON.stringify(this.selectedFilters),
            filterName: this.filterForEdit.name,
            id: this.filterForEdit.id // Use the ID of the filter being updated
        };

        this.portalProfileService.setSavedFilters(filterData).subscribe((res) => {
            if (res) {


                // Update the saved filters list
                this.savedFilters = this.savedFilters.map(filter => {
                    if (filter.id === this.filterForEdit.id) {
                        return {
                            ...filter,
                            name: this.filterForEdit.name,
                            value: JSON.stringify(this.selectedFilters),
                            selected: true
                        };
                    } else {
                        return { ...filter, selected: false };
                    }
                });

                this.isEditFilter = false;
                this.messageService.add({
                    key: 'bcu', severity: 'success',
                    detail: 'Filter ' + '“' + this.filterForEdit.name + '” updated successfully.',
                    data: 'filterModified',
                    life: 10000,
                });


                // Update the selected filters and UI
                this.selectFilter({
                    id: this.filterForEdit.id,
                    value: JSON.stringify(this.selectedFilters),
                    name: this.filterForEdit.name
                });
            }
        });
    }
    onFilterChange(): void {
        // Check if any filter is selected in either selectedFilters or selectedAutoCompleteFilters
        this.isSaveFilterEnabled = Object.values(this.selectedFilters).some(value => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== null && value !== undefined && value !== '';
        }) || Object.values(this.selectedAutoCompleteFilters).some(value => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== null && value !== undefined && value !== '';
        });
    }

    clearFilter() {
        // Reset filter selection status
        this.filterService.setIsFilterSelectedStatus(false);
        this.savedFilters?.forEach(filter => filter.selected = false);
        // Initialize empty filter structure
        const emptyFilter = {
            companies: this.selectedFilters?.companies || [], // Preserve companies
            representatives: [],
            customerServiceRepresentatives: [],
            sbus: [],
            serviceCodes: [],
            carriers: [],
            flights: [],
            originRegion: [],
            originCountry: [],
            portOfDeparture: [],
            destinationRegion: [],
            destinationCountry: [],
            portOfArrival: [],
            placeOfReceipt: [],
            placeOfDelivery: [],
            events: [],
            exception: 0,
            shipmentType: 0,
            statusType: ""
        };

        // Safely reset selected filters
        this.selectedFilters = { ...emptyFilter };
        this.resetCountries();
        // Reset autocomplete selections with null check
        if (this.selectedAutoCompleteFilters) {
            Object.keys(this.selectedAutoCompleteFilters).forEach(key => {
                this.selectedAutoCompleteFilters[key] = [];
            });
        }

        // Reset change detector states if exists
        if (this.changeDetector) {
            Object.keys(this.changeDetector).forEach(key => {
                this.changeDetector[key] = false;
            });
        }

        // Update filter service
        const filters = this.filterService.getIds(this.selectedFilters);
        this.filterService.filterSelectionDownloadOption.next("");
        this.filterService.updateFilterSelection(filters, "ClearFilter");
        this.storageService.setItem("filters", filters);

        // Disable the "Save Current Filter Criteria" button
        this.isSaveFilterEnabled = false;
        this.changeDetector.filterUpdated = false;
        this.filterService.setIsFilterSelectedStatus(false);
        // Force UI update
        this.changeDetectorRef.detectChanges();
    }
}
